import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ViewContainerRef, ComponentFactoryResolver, ApplicationRef, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Device } from 'src/app/core/models/project/devices/device.model';
import { Action } from 'src/app/core/models/automation/action.model';
import { Property } from 'src/app/core/models/project/property.model';
import { EquipmentBinaryMutexComponent } from 'src/app/shared/components/equipment/equipment-binary-mutex/equipment-binary-mutex.component';
import { EquipmentComponentGenService } from 'src/app/shared/services/equipment-component-gen.service';
import { Subscription } from 'rxjs';
import { EquipmentPropertyComponentToLoad } from 'src/app/core/models/equipment-property-component-to-load.model';
import { EquipmentPropertyTypesService } from '../../services/equipment-property-types.service';
import { UserService } from 'src/app/core/services/user.service';
import { User } from 'src/app/core/models/user/user.model';
import { Room } from 'src/app/core/models/project/room.model';
import { ProjectService } from 'src/app/modules/project/services/project.service';
import { Floor } from 'src/app/core/models/project/floor.model';
import { DaliProjectService } from 'src/app/modules/project/services/dali-project.service';
import { Light } from 'src/app/core/models/project/devices/light.model';
import { ToastController } from '@ionic/angular';
import { GenComTranslatePipe } from '../../pipes/gen-com-translate.pipe';
import { EquipmentNumberComponent } from '../equipment/equipment-number/equipment-number.component';

@Component({
  selector: 'app-setup-device-action',
  templateUrl: './setup-device-action.component.html',
  styleUrls: ['./setup-device-action.component.scss']
})
export class SetupDeviceActionComponent implements OnInit, OnDestroy {
  @ViewChild('equipmentPropertyContainer', { read: ViewContainerRef }) equipmentPropertyContainer;
  @Input() deviceInSetup: Device;
  @Input() deviceInSetupAction: Action;
  @Output() deviceAction$: EventEmitter<Action> = new EventEmitter();
  @Output() propName$?: EventEmitter<String> = new EventEmitter();
  step: 'select property' | 'select action' = 'select property';
  equipmentProperties: Property[];
  componentToLoadSubscriptions: Subscription = new Subscription();
  action: Action;
  deviceIsDali: boolean = false;

  constructor(
    private equipmentPropertyTypesService: EquipmentPropertyTypesService,
    private equipmentComponentGen: EquipmentComponentGenService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private changeDetectorRef: ChangeDetectorRef,
    private userService: UserService,
    private projectService: ProjectService,
    private daliProjectService: DaliProjectService,
    private pipe: GenComTranslatePipe,
    private toastController: ToastController) { }

  ngOnInit(): void {
    this.isDeviceDali(this.deviceInSetup);
    if (this.deviceIsDali) {
      this.step = 'select action';
      this.propName$.emit(this.deviceInSetup.name)
    } else {
      if (this.deviceInSetupAction) {
        this.action = JSON.parse(JSON.stringify(this.deviceInSetupAction));
        this.step = 'select action';
        const propToLoad = this.getPropertyForAction(this.deviceInSetup, this.action);
        this.selectEquipProp(propToLoad);
      } else {
        this.equipmentProperties = this.initEquipmentPropertyArray(this.deviceInSetup.equipmentProperties);
        if (this.equipmentProperties.length == 1){
          this.selectEquipProp(this.equipmentProperties[0]);
          } else {
            this.propName$.emit(null)
          }
      }
    }
  }


  isDeviceDali(device: any) {
    if (this.daliProjectService.getDaliLight(device.id)) {
      this.deviceIsDali = true;
    } else if (this.daliProjectService.getDaliRgbLight(device.id)) {
      this.deviceIsDali = true;
    } else if (this.daliProjectService.getDaliLightsGroup(device.id)) {
      this.deviceIsDali = true;
    } else if (this.daliProjectService.getDaliBlinds(device.id)) {
      this.deviceIsDali = true;
    }
  }

  daliLightIsNormal(daliLight) {
    return Light.isDimmableDaliLight(daliLight) || Light.isNormalDaliLight(daliLight);
  }

  daliLightIsRgb(daliLight) {
    return (daliLight?.id?.split('-')[0] === 'DRGB');
  }

  isDaliGroup(daliLight) {
    return (daliLight?.id?.split('-')[0] === 'DG');
  }

  isDaliBlinds(daliLight) {
    return (daliLight?.id?.split('-')[0] === 'DBL');
  }

  getPropertyForAction(device: Device, action: Action): Property {
    const propertyType  = action.parameters[0].split('/')[1];
    const equipmentProperty: Property =  device.equipmentProperties.find( (prop: Property) => {
      return prop.type === +propertyType; });
    return equipmentProperty;
  }

  initEquipmentPropertyArray(deviceEquipProperties: Property[]) {
    let noHvacMutex = true;
    let noBlindsMutex = true;
    const user = this.userService.getUser();
    const equipmentProperties = deviceEquipProperties.filter((prop: Property) => {
      if (this.equipmentPropertyTypesService.getEquipmentPropertyType(prop.type)
      || this.equipmentPropertyTypesService.getEquipmentPropertyTypeForStatus(prop.type)
     /*  || this.equipmentPropertyTypesService.getEquipmentPropertyTypeForAdmin(prop.type) */) {
      if (Property.isHvacMutex(prop)){
        if (noHvacMutex) {
        noHvacMutex = false;
        if (User.isAdmin(user)) {
          return true;
        } else {return prop.isActuatorProperty; }
       } else {return false; }}
       else if (Property.isBlindsMutex(prop)){
        if (noBlindsMutex) {
          noBlindsMutex = false;
          if (User.isAdmin(user)) {
            return true;
          } else {return prop.isActuatorProperty; }
        } else {return false; }
       }
       else {
        if (User.isAdmin(user)) {
          return true;
        } else {return prop.isActuatorProperty; }}
      }
    });
    return equipmentProperties;
  }


  getEquipmentPropertyName(equipmentProperty: Property): string {
    if (Property.isHvacMutex(equipmentProperty)) {
      return 'Hvac control';
    } else if (Property.isBlindsMutex(equipmentProperty)) {
      return 'Blinds';
    } else {
      return equipmentProperty.name;
    }
  }


  selectEquipProp(equipmentProperty: Property) {
    this.propName$.emit(this.getEquipmentPropertyName(equipmentProperty))
    this.step = 'select action';
    this.changeDetectorRef.detectChanges(); // trigers change detection to render #equipmentPropertyContainer
    this.loadEquipmentPropertyComponent(equipmentProperty);
  }


  loadEquipmentPropertyComponent(equipProp: Property) {
    if (Property.isHvacMutex(equipProp) || Property.isBlindsMutex(equipProp)){
      const viewContainerRef: ViewContainerRef = this.equipmentPropertyContainer;
      viewContainerRef.clear();
      const mutexComponentFactory = this.componentFactoryResolver.resolveComponentFactory(EquipmentBinaryMutexComponent);
      const mutexComponentRef = viewContainerRef.createComponent(mutexComponentFactory);

      const generatedComponentInstance = (mutexComponentRef.instance as EquipmentBinaryMutexComponent);

      if (Property.isHvacMutex(equipProp)) {
        const hvacControlPropertyArray = this.deviceInSetup.equipmentProperties.filter((prop) => {
          return Property.isHvacMutex(prop);
         });
        generatedComponentInstance.propertyArray = hvacControlPropertyArray;
        generatedComponentInstance.title = 'HVAC control';
      } else if (Property.isBlindsMutex(equipProp)){
        const blindsPropertyArray = this.deviceInSetup.equipmentProperties.filter((prop) => {
          return Property.isBlindsMutex(prop);
         });
        generatedComponentInstance.propertyArray = blindsPropertyArray;
        generatedComponentInstance.title = 'Blinds';
      }
      generatedComponentInstance.parentDevice = this.deviceInSetup;
      generatedComponentInstance.inputAction = this.action;
      generatedComponentInstance.mode = 'action';
      this.componentToLoadSubscriptions.add((mutexComponentRef.instance as EquipmentBinaryMutexComponent ).actionChanged$
        .subscribe((changedAction: Action) => {
          this.action = changedAction;
      }));

    } else if (Property.isBlindsV2Percent(equipProp)) {
      const viewContainerRef: ViewContainerRef = this.equipmentPropertyContainer;
      viewContainerRef.clear();
      const mutexComponentFactory = this.componentFactoryResolver.resolveComponentFactory(EquipmentNumberComponent);
      const mutexComponentRef = viewContainerRef.createComponent(mutexComponentFactory);

      const generatedComponentInstance = (mutexComponentRef.instance as EquipmentNumberComponent);

      generatedComponentInstance.equipmentProperty = equipProp;
      generatedComponentInstance.parentDevice = this.deviceInSetup;
      generatedComponentInstance.actionInput = this.action;
      generatedComponentInstance.mode = 'action';
      generatedComponentInstance.data = {unitOfMeasurement: '%'}
      this.componentToLoadSubscriptions.add((mutexComponentRef.instance as EquipmentNumberComponent ).actionChanged$
        .subscribe((changedAction: Action) => {
          this.action = changedAction;
      }));
    } else {
      let componentToLoad: EquipmentPropertyComponentToLoad;
      if (this.equipmentPropertyTypesService.getEquipmentPropertyType(equipProp.type)) {
        componentToLoad = this.equipmentComponentGen.getComponent(equipProp, this.deviceInSetup);
      } else if (this.equipmentPropertyTypesService.getEquipmentPropertyTypeForStatus(equipProp.type)) {
        componentToLoad = this.equipmentComponentGen.getComponentForStatus(equipProp, this.deviceInSetup);
      } /* else if (this.equipmentPropertyTypesService.getEquipmentPropertyTypeForAdmin(equipProp.type)) {
        componentToLoad = this.equipmentComponentGen.getComponentForAdmin(equipProp, this.deviceInSetup);
      } */
      const viewContainerRef: ViewContainerRef = this.equipmentPropertyContainer;
      viewContainerRef.clear();
      const {component, parentDevice, equipmentProperty, equipmentPropertyType, data } = componentToLoad;
      const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
      const componentRef = viewContainerRef.createComponent(componentFactory);
      const generatedComponentInstance = (componentRef.instance as EquipmentPropertyComponentToLoad);
      generatedComponentInstance.parentDevice = parentDevice;
      generatedComponentInstance.equipmentProperty = equipmentProperty;
      generatedComponentInstance.equipmentPropertyType = equipmentPropertyType;
      generatedComponentInstance.data = data;
      generatedComponentInstance.mode = 'action';
      generatedComponentInstance.actionInput = this.action;

      this.componentToLoadSubscriptions.add(generatedComponentInstance.actionChanged$
        .subscribe((changedAction: Action) => {
          this.action = changedAction;
      }));
    }
  }


  getRoom(device: Device): Room {
    const deviceLocation: string = device.listOfLocationIds[0];
    const splitRoomId = deviceLocation.split('.');
    const roomId = `${splitRoomId[0]}.${splitRoomId[1]}.${splitRoomId[2]}`;
    const room: Room = this.projectService.getRoom(roomId);
    return room;
  }


  getFloor(device: Device): Floor {
    const room: Room = this.getRoom(device);
    const floor: Floor = this.projectService.getFloor(room.floorId);
    return floor;
   }

   actionChanged(action: Action) {
     this.action = action;
   }

  onCancel() {
      this.deviceAction$.emit(null);
  }

  async onApply() {
    if (this.action) {
      this.deviceAction$.emit(this.action);
      const toast = await this.toastController.create({
        message: this.pipe.transform('Device ') + this.deviceInSetup.name + this.pipe.transform(' added'),
        color: 'primary',
        duration: 2000,
      });
      toast.present();
    }
  }

  ngOnDestroy() {
    if (this.componentToLoadSubscriptions) {
      this.componentToLoadSubscriptions.unsubscribe();
    }
  }

}
